// extracted by mini-css-extract-plugin
module.exports = {"idmLabel":"src-lib-app-components-elements-textDisplays-Label-index-module__idmLabel--1Go-j"};